<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <div
      v-if="active"
      ref="alert"
      class="con-vs-alert"
      :class="[`con-vs-alert-${color}`, { 'con-icon': icon }]"
      :style="styleAlert"
    >
      <div
        v-if="closable"
        class="con-x vs-alert--close"
        @click="$emit('update:active', false)"
      >
        <vs-icon :icon-pack="iconPack" :icon="closeIcon" />
      </div>
      <h4
        v-if="title"
        class="titlex vs-alert--title"
        :style="styleTitle"
        v-text="title"
      />
      <div class="vs-alert" :class="{ 'con-icon': icon }">
        <vs-icon
          v-if="icon"
          class="icon-alert"
          :icon-pack="iconPack"
          :icon="icon"
        />
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
import color from "@/assets/utils/color";

function resolveColor(value, opacity = 1) {
  return color.isColor(value)
    ? `rgba(var(--vs-${value}), ${opacity})`
    : color.getColor(value, opacity);
}

export default {
  name: "VsAlert",
  props: {
    active: {
      type: [Boolean, String],
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    margin: {
      type: [String, Boolean],
      default: "10px",
    },
    icon: {
      type: String,
      default: null,
    },
    closeIcon: {
      type: String,
      default: "close",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
  },
  emits: ["update:active"],
  computed: {
    styleAlert() {
      return {
        background: resolveColor(this.color, 0.15),
        boxShadow: `0px 0px 25px 0px ${resolveColor(this.color, 0.15)}`,
        color: resolveColor(this.color),
      };
    },
    styleTitle() {
      return {
        boxShadow: `0px 6px 15px -7px ${resolveColor(this.color, 0.4)}`,
      };
    },
  },
  mounted() {
    if (this.$refs.alert) {
      this.$nextTick(() => {
        this.$refs.alert.style.height = `${this.$refs.alert.scrollHeight}px`;
      });
    }
  },
  methods: {
    beforeEnter(element) {
      element.style.height = 0;
      element.style.opacity = 0;
    },
    enter(element, done) {
      element.style.height = `${element.scrollHeight}px`;
      element.style.opacity = 1;
      done();
    },
    leave(element) {
      element.style.height = "0px";
      element.style.opacity = 0;
    },
  },
};
</script>
